export default {
  sn: '',
  alias: '',
  ip_address: '',
  heartbeat: '',
  company_id: '',
  branch_office_id: '',
  company: {},
  branch_office: {},
  companies: [],
  origin: 'biotime'
};
